<mat-form-field class="autocomplete-input" [appearance]="appearance" [class.list-selected]="listSelected"
    (mouseover)="listSelected=true" (mouseout)="listSelected=false">
    <mat-chip-list #chipList aria-label="Category selection">
        <div class="chip-block">
            @for (item of selectedItems; track item) {
            <mat-chip selectable="false" [removable]="true" (click)="onChipClick(item)" (removed)="onRemove(item)">
                {{item.name}}
                <mat-icon matChipRemove>cancel</mat-icon>
            </mat-chip>
            }
        </div>
        <input #searchTextInput type="text" [(ngModel)]="inputValue" [placeholder]="placeholder"
            [formControl]="inputValueControl" [matAutocomplete]="auto" [matChipInputFor]="chipList">
    </mat-chip-list>
    <mat-autocomplete #auto="matAutocomplete" class="mat-select-panel" [ngClass]="autocompleteClass"
        [autoActiveFirstOption]="true" (closed)="releaseFilter()">
        @for (option of data; track option; let last = $last) {
        <mat-option (onSelectionChange)="optionSelected(option)" [value]="option"
            [ngClass]="{'flavor-text-line-break' : flavorTextLineBreak }">
            @if (!isCheckbox) {
            <span [ngClass]="{'selected-item': isSelected(option) }">
                {{ option.name }}
                <ng-container [ngTemplateOutlet]="flavorText" [ngTemplateOutletContext]="{data: option}"></ng-container>
            </span>
            }
            @if (isCheckbox) {
            <mat-checkbox (click)="$event.stopPropagation()" (change)="optionSelected(option)"
                [checked]="isSelected(option)">{{ option.name }}</mat-checkbox>
            }
        </mat-option>
        }
        @if (data && data.length >= maxDataRows) {
        <div class="over-records">
            <span>Displaying 1st {{maxDataRows}} results.</span><br />
            <span>Keep typing to refine further.</span>
        </div>
        }
    </mat-autocomplete>
    @if (selectedItems?.length > 1) {
    <button mat-icon-button class="icon-close" aria-label="close" (click)="clearAll()">
        <mat-icon>close</mat-icon>
    </button>
    }
</mat-form-field>